import axios from 'axios';
import Resource from './Resource'
import Plan from './Plan'
import { compare } from '@/utils/util'

export default class Subject extends Resource {
  static ENDPOINT = '/api/subject'

  constructor (args) {
    super()
    Object.keys(args).forEach(arg => {
      this[arg] = args[arg]
    })
  }

  static async getSubjects (training) {
    const { data } = await axios.get(`${this.ENDPOINT}`, { params: { training } });
    if (data) {
      data.CULTURE = data.CULTURE.map(s => new Subject(s))
      data.NCS = data.NCS.map(s => new Subject(s))
      // pland을 Plan 모델로 변환
      data.NCS.forEach(s => {
        s.plan = new Plan(s.plan)
      })
      data.NONNCS = data.NONNCS.map(s => new Subject(s))
      // pland을 Plan 모델로 변환
      data.NONNCS.forEach(s => {
        s.plan = new Plan(s.plan)
      })
    }
    return data
  }

  static create (category, training) {
    const lectures = []
    return new Subject({ category, training, lectures })
  }
}
